var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefreshIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9312 5.77217C11.7641 4.56989 11.2063 3.4559 10.3438 2.60179C9.48135 1.74768 8.36196 1.20084 7.15811 1.04551C5.95426 0.890172 4.73273 1.13496 3.68169 1.74216C2.63064 2.34936 1.80839 3.28529 1.3416 4.40578M1 1.67299V4.40578H3.73279M1 7.13856C1.16708 8.34084 1.72483 9.45484 2.58731 10.3089C3.4498 11.1631 4.56919 11.7099 5.77304 11.8652C6.97689 12.0206 8.19842 11.7758 9.24947 11.1686C10.3005 10.5614 11.1228 9.62545 11.5896 8.50496M11.9312 11.2377V8.50496H9.19836",
    stroke: "#0152E9",
    strokeWidth: 1.36639,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefreshIcon);
export default __webpack_public_path__ + "static/media/refresh-icon.f5c35010349c55ad6f27a6c9dc035ff5.svg";
export { ForwardRef as ReactComponent };